<template>
  <div class="refund-audit">
    <div class="searchbox">
      <form action="#" method="get" class="form-inline form-float">
        <div class="form-group">
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            :editable="false"
            v-model="search.startTime"
            type="datetime"
            placeholder="选择日期时间"
          ></el-date-picker>
        </div>
        <div class="form-group">
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            :editable="false"
            v-model="search.endTime"
            type="datetime"
            placeholder="选择日期时间"
          ></el-date-picker>
        </div>
        <div class="form-group others">
          <span class="search_btn">
            <button @click="searchList" type="button" class="btn btn-primary" id="search_btn" :disabled="loading">
              <i v-if="loading" class="el-icon-loading"></i>
              {{ loading ? "查询中..." : "查询" }}
            </button>
          </span>
          
        </div>
      </form>
    </div>
    <div class="list-right">
      <el-table v-loading="loading" element-loading-text="加载中..."
        ref="table"
        border
        :data="tableListData"
        height="100%"
        :header-cell-style="tableHeaderStyle"
        :cell-style="styleObj"
      >
        <el-table-column show-overflow-tooltip label="申请时间" prop="crtTime"></el-table-column>
        <el-table-column show-overflow-tooltip label="手机号">
          <!-- <template slot-scope='scope'>
					{{scope.row.userId?JSON.parse(scope.row.userId).mobile:''}}
          </template>-->
        </el-table-column>
        <el-table-column show-overflow-tooltip label="内容" prop="content">
          <template slot-scope="scope">{{scope.userType==1?'管理员用户':'普通用户'}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="操作" width="200px">
          <template slot-scope="scope">
            <button
              class="chargingRules"
              type="button"
              @click="accectRefunds(scope.row.orderNum)"
            >同意</button>
            <button class="edit" type="button" @click="refuseRefunds(scope.row.id)">拒绝</button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <Page :pageSize="search.pageSize"></Page> -->
    <Page v-on:pagination="receivePaginationData"></Page>
    <!--拒绝退款-->
    <el-dialog
      :lock-scroll="false"
      :close-on-click-modal="false"
      title="拒绝退款"
      :visible.sync="dialogFormVisibleRefuse"
    >
      <el-form>
        <el-form-item label="理由" :label-width="formLabelWidth">
          <el-input type="textarea" autosize v-model="refuseData.content"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="refuseRefundsTrue">确 定</el-button>
        <el-button @click="dialogFormVisibleRefuse = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getRefundMessage, acceptRefund, refuseRefund } from "@/api/url";
import { mapState, mapMutations, mapGetters } from "vuex";
import Page from "../../commons/page";
// import Refresh from "../commons/refresh.vue";
export default {
  data() {
    return {
      loading: false,
      dialogFormVisibleRefuse: false,
      formLabelWidth: "100",
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      search: {
        pageSize: 10,
        pageNumber: 1,
        startTime: "",
        endTime: "",
      },
      tableListData: [],
      refundData: {
        orderNum: "",
      },
      refuseData: {
        content: "",
        id: "",
      },
    };
  },
  methods: {
    ...mapMutations(["getPage", "storageScenId"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    tableList(curPage) {
      var _this = this;
      this.$get(getRefundMessage(), {
        proSign: "running",
        beginTime: this.search.startTime,
        endTime: this.search.endTime,
        limit: this.search.pageSize,
        page: curPage,
      }).then((data) => {
        if (data.status != 200) return;
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.getPage(pageObj);
        _this.tableListData = data.data.rows;
        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      });
    },
    accectRefunds(n) {
      var _this = this;
      _this.refundData.orderNum = n;
      var index = _this.$layer.confirm(
        "您确定同意退款",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function () {
          _this.$layer.close(index);

          _this
            .$postRequest(acceptRefund(), {
              orderNum: _this.refundData.orderNum,
            })
            .then((data) => {
              if (data.status != 200) return;
              _this.$notify({
                type: "success",
                title: "成功",
                message: "同意退款！",
              });
              _this.tableList(this.curIndex);
            });
        }
      );
    },
    refuseRefunds(id) {
      this.dialogFormVisibleRefuse = true;
      this.refuseData.id = id;
    },
    refuseRefundsTrue() {
      var _this = this;
      this.dialogFormVisibleRefuse = false;
      this.$postRequest(refuseRefund(), {
        id: this.refuseData.id,
        proSign: "complete",
        attr1: this.refuseData.content,
        readFlag: "y",
      }).then((data) => {
        if (data.status != 200) return;
        _this.$notify({
          type: "success",
          title: "成功",
          message: "已处理，不同意退款！",
        });
        _this.tableList(this.curIndex);
      });
    },
    searchList: function () {
      if (this.loading) return;
      var flTime = this.timeCompare(this.search.startTime, this.search.endTime);
      // console.log(this.search.endTime)
      if (flTime) {
        return this.$layer.msg("开始时间请勿大于结束时间", { time: 1 });
      } else if (
        !Boolean(this.search.startTime) &&
        Boolean(this.search.endTime)
      ) {
        return this.$layer.msg("请选择开始时间", { time: 1 });
      } else if (
        Boolean(this.search.startTime) &&
        !Boolean(this.search.endTime)
      ) {
        return this.$layer.msg("请选择结束时间", { time: 1 });
      }

      this.search.pageNumber = "1";
      this.tableList(this.search.pageNumber);
    },
    timeCompare: function (bDateVal, eDateVal) {
      // console.log(bDateVal,eDateVal);

      if (!Boolean(bDateVal) || !Boolean(eDateVal)) {
        return false;
      }

      var bdate = new Date(Date.parse(bDateVal.replace(/-/g, "/")));
      bdate = bdate.getTime();
      var edate = new Date(Date.parse(eDateVal.replace(/-/g, "/")));
      edate = edate.getTime();
      if (bdate - edate > 0) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {
    this.tableList(this.search.pageNumber);
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
    ...mapGetters(["elements"]),
    permiss() {
      // this.manager_btn_edit = this.elements['manager:btn_edit'];
      // this.manager_btn_delete = this.elements['manager:btn_delete'];
    },
  },
  components: {
    Page,
    // Refresh
  },
};
</script>
<style>
</style>